import { Components, Theme } from '@mui/material'

// I don't know why but it doesn't work as expected
// In .css-*******-MuiScopedCssBaseline-root styles remains
// font-family: "Roboto","Helvetica","Arial",sans-serif;
const MuiScopedCssBaseline: Components<Theme>['MuiScopedCssBaseline'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontFamily: theme.fonts.family.PlusJakartaSans,
    }),
  },
}

export default MuiScopedCssBaseline
